import { Box, TextField, Typography } from '@material-ui/core';
import { getButtonStyles } from 'src/components/CustomComponents/CustomButton';
import React, { ComponentProps } from 'react';

type Props = ComponentProps<typeof TextField> & { size?: 'large' | 'medium' | 'small' | 'xs' };

const CustomFormInput = ({ error, size = 'medium', sx = {}, label, ...props }: Props) => {
  const btnStyles = getButtonStyles('default', size, 'outline');

  return (
    <Box sx={{ position: 'relative' }}>
      <TextField
        sx={{
          width: '100%',
          '.MuiFormHelperText-root': {
            pointerEvents: 'none',
            position: 'absolute',
            right: '10px',
            paddingInline: '4px',
            bottom: '-8px',
            background: 'white',
            color: error ? 'red' : 'inherit',
          },
          '.MuiOutlinedInput-root': {
            ...btnStyles,
            paddingBlock: 0,
            paddingLeft: 0,
            '&:active': { opacity: 1 },
            ...(error
              ? {
                  borderColor: 'red',
                  '&:hover': { borderColor: 'red' },
                  '.MuiOutlinedInput-input::placeholder': { color: 'red' },
                }
              : {}),
            '& fieldset': {
              borderWidth: '0px',
            },
            '&:hover fieldset': {
              borderWidth: '0px',
              transform: 'none',
            },
            '&.Mui-focused fieldset': {
              borderWidth: '0px',
            },
            '& > .MuiOutlinedInput-input': {
              padding: 0,
              paddingInline: 'padding' in btnStyles ? btnStyles.padding : '10px',
              height: '100% !important',
              color: error ? 'red' : 'inherit',
            },
            width: '100% !important',
            ...sx,
          },
        }}
        {...props}
      />
      <Typography
        variant="font21"
        sx={{
          position: 'absolute',
          top: '-8px',
          left: '10px',
          paddingInline: '4px',
          background: 'white',
          color: error ? 'red' : '#86909F',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default CustomFormInput;
